/* import __COLOCATED_TEMPLATE__ from './mcp-template-list.hbs'; */
/* RESPONSIBLE TEAM: team-data-foundations */

import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import type IntlService from 'embercom/services/intl';
import {
  getAllMcpTemplates,
  type McpTemplateDefinition,
} from 'embercom/models/workflow-connector/constants/mcp-templates';

interface Args {
  mcpActions: any[];
  showMcpServerModal: () => void;
  onTemplateSelect: (template: Template) => void;
}

export interface Template {
  name: string;
  description: string;
  icon: string;
  shouldDisplay: boolean;
  template: boolean;
  authentication?: string;
  url?: string;
  id?: string;
}

export default class McpTemplateList extends Component<Args> {
  @service declare intl: IntlService;

  shouldDisplayTemplate(mcpTemplate: McpTemplateDefinition): boolean {
    return mcpTemplate.shouldDisplay !== undefined
      ? mcpTemplate.shouldDisplay
      : !this.args.mcpActions.some((mcpAction) => mcpAction.mcp_server_name === mcpTemplate.name);
  }

  get templateList(): Template[] {
    let templates: Template[] = [
      {
        name: this.intl.t('workflow-connector.actions.mcp-actions.template-list.custom-mcp-title'),
        description: this.intl.t(
          'workflow-connector.actions.mcp-actions.template-list.custom-mcp-description',
        ),
        icon: 'mcp/custom-add',
        shouldDisplay: true,
        template: false,
        id: 'custom-mcp-server',
      },
    ];

    let mcpTemplates = getAllMcpTemplates();
    for (let mcpTemplate of mcpTemplates) {
      templates.push({
        name: mcpTemplate.name,
        url: mcpTemplate.url,
        description: this.intl.t(mcpTemplate.descriptionKey),
        icon: mcpTemplate.icon,
        shouldDisplay: this.shouldDisplayTemplate(mcpTemplate),
        template: true,
        authentication: mcpTemplate.authentication,
        id: mcpTemplate.id,
      });
    }

    return templates;
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'WorkflowConnector::McpTemplateList': typeof McpTemplateList;
  }
}
